import type { Metric } from "@/services/api/types";
import { buildQueryString, fuseBaseServiceUrl } from "@/services/endpoints-url";

export async function putMetric(metric: Metric, token: string, signal?: AbortSignal): Promise<Metric | undefined> {
  try {
    const params = new URLSearchParams({
      productType: "monday",
    });

    const response = await fetch(`/api/metrics?${params.toString()}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token,
      },
      body: JSON.stringify(metric),
      signal,
    });

    if (!response.ok) {
      return undefined;
    }

    const responseText = await response.text();

    return (responseText ? JSON.parse(responseText) : {}) as Metric;
  } catch (error) {
    // TODO handle error
    console.error("Error:", error);
    return undefined;
  }
}
export const fetchMetrics = async (sessionToken: string): Promise<Metric[]> => {
  const fuseBaseUrl = fuseBaseServiceUrl();
  const queryString = buildQueryString({
    productType: "monday",
  });
  const metricName = "StartCloning";
  const resultsUrl = `${fuseBaseUrl}/api/metrics/${metricName}?${queryString}`;
  const response = await fetch(resultsUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": sessionToken,
    },
  });
  if (!response.ok) {
    return [];
  }
  const responseText = await response.text();

  const retMetric = (responseText ? JSON.parse(responseText) : {}) as Metric;
  return [retMetric];
};
